import React, { useState, useEffect } from "react";
import MenubarUser from "../../layouts/MenubarUser";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getWishlist, removeWishlist } from "../../function/users";
import { HeartFilled, DeleteOutlined, ShoppingOutlined } from "@ant-design/icons";
import "./WishList.css";

const WishList = () => {
  const [wishlist, setWishList] = useState([]);
  const { user } = useSelector((state) => ({ ...state }));

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    getWishlist(user.token).then((res) => {
      setWishList(res.data.wishlist);
    });
  };

  const handleRemove = (productId) => {
    removeWishlist(user.token, productId).then(() => {
      loadData();
    });
  };

  return (
    <div className="order-page">
      <div className="order-layout">
        <div className="order-sidebar">
          <MenubarUser />
        </div>

        <div className="order-main">
          <div className="order-page-header">
            <h4 className="order-page-title">สินค้าที่ชื่นชอบ</h4>
            <span className="order-count-badge">{wishlist.length} รายการ</span>
          </div>

          {wishlist.length === 0 ? (
            <div className="order-empty">
              <HeartFilled className="order-empty-icon" style={{ color: "#f0c0d4" }} />
              <p>ยังไม่มีสินค้าที่ชื่นชอบ</p>
              <Link to="/shop" className="wishlist-browse-btn">
                <ShoppingOutlined />
                เลือกสินค้า
              </Link>
            </div>
          ) : (
            <div className="wishlist-grid">
              {wishlist.map((item, index) => (
                <div key={index} className="wishlist-card">
                  {/* รูปสินค้า */}
                  <div className="wishlist-img-wrap">
                    {item.images?.[0]?.url ? (
                      <img
                        src={item.images[0].url}
                        alt={item.title}
                        className="wishlist-img"
                      />
                    ) : (
                      <div className="wishlist-img-placeholder">
                        <ShoppingOutlined />
                      </div>
                    )}
                  </div>

                  {/* ข้อมูลสินค้า */}
                  <div className="wishlist-info">
                    <Link to={"/product/" + item._id} className="wishlist-title">
                      {item.title}
                    </Link>
                    {item.price && (
                      <span className="wishlist-price">
                        {Number(item.price).toLocaleString("th-TH", {
                          minimumFractionDigits: 2,
                        })}{" "}
                        บาท
                      </span>
                    )}
                  </div>

                  {/* ปุ่มลบ */}
                  <button
                    className="wishlist-remove-btn"
                    onClick={() => handleRemove(item._id)}
                    aria-label="ลบออกจาก wishlist"
                  >
                    <DeleteOutlined />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WishList;